export const styles = {
  // page container tweaks for subtle breathing room on mobile-first layout
  container: {
    paddingLeft: '0.75rem',
    paddingRight: '0.75rem'
  },

  toggleButton: night => ({
    border: '1px solid',
    borderColor: night ? '#aaa' : '#222',
    borderRadius: '9999px',
    px: 3,
    py: 1,
    minHeight: '2.5em',
    lineHeight: '1.2',
    fontFamily: 'Menlo, ui-monospace, monospace',
    fontSize: 2,
    background: 'transparent',
    color: night ? '#f5f5f5' : '#222',
    cursor: 'pointer',
    transition: 'background 0.2s, color 0.2s, border-color 0.2s',
    ':hover': {
      backgroundColor: night ? '#222' : '#f5f5f5',
    },
    boxShadow: '0 1px 4px rgba(0,0,0,0.03)'
  }),

  // hero heading refinements
  heroHeading: {
    fontFamily: 'Menlo, ui-monospace, monospace',
    letterSpacing: '-0.02em',
    fontWeight: 600,
    marginBottom: '0.25rem'
  },

  subtitle: {
    fontFamily: 'Menlo, ui-monospace, monospace',
    color: 'gray',
    marginBottom: '1rem'
  },

  // card that contains the list of tools
  toolsCard: night => ({
    background: night ? 'rgba(255,255,255,0.04)' : 'rgba(0,0,0,0.03)',
    borderRadius: '12px',
    padding: '0.75rem',
    boxShadow: night
      ? '0 6px 18px rgba(0,0,0,0.3)'
      : '0 6px 18px rgba(16,24,40,0.04)',
    width: '100%'
  }),

  // individual tool card / link
  toolCard: night => ({
    display: 'block',
    textDecoration: 'none',
    borderRadius: '10px',
    padding: '0.75rem',
    marginBottom: '0.6rem',
    background: night ? 'rgba(255,255,255,0.02)' : '#fff',
    border: '1px solid',
    borderColor: 'rgba(0,0,0,0.06)',
    color: night ? '#f5f5f5' : '#111',
    transition: 'transform 0.12s ease, box-shadow 0.12s ease',
    boxShadow: '0 2px 6px rgba(11,15,26,0.04)',
    fontFamily: 'Menlo, ui-monospace, monospace'
  }),

  toolText: {
    fontFamily: 'Menlo, ui-monospace, monospace',
    marginBottom: '0.35rem'
  },

  toolLink: {
    textDecoration: 'none',
    fontFamily: 'Menlo, ui-monospace, monospace',
    fontSize: '1.05em',
    display: 'block'
  },

  toolItem: {
    marginBottom: '0.8rem'
  }
};
